import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'forestone',
} as IModuleProps;
